<div class="app-container">
  <div style="margin:15px">
    <mat-card-header style="display:flex; padding: 0;">
      <img mat-card-avatar src="/assets/images/third-party-clio-logo.png" style="width: 25px; height: 25px;">
      <mat-card-title>Clio</mat-card-title>
      <div *ngIf="!isLoading && isLinked" style="font-size: 10px;" class="flex--column flex-align--flex-end">LINKED</div>
    </mat-card-header>
    <p style="font-size: 14px; margin: 14px 0;">
      Clio is a legal technology company that offers law firms cloud-based software that handles various law practice management tasks including client intake, contact management, calendaring, document management, timekeeping, billing, and trust accounting.
    </p>
    <button *ngIf="isLoading" mat-stroked-button [disabled]="disabled" color="basic" style="width: 100%; pointer-events:none">
      <mat-icon><mat-spinner color="primary" diameter="20"></mat-spinner></mat-icon>
    </button>
    <button *ngIf="!isLoading && !isLinked" mat-flat-button color="primary" style="width:100%; cursor:pointer;" (click)="learnMore()">Learn More</button>
    <button *ngIf="!isLoading && isLinked" mat-stroked-button color="primary" style="width: 100%;" (click)="unlink()">Unlink</button>
  </div>
</div>

